import React from 'react'
import { ListNav } from './index'
import { FloatingFilter } from '../../../components'
import { Featured } from './featured'
import PaginatedList from './paginated-list'
import { useInternationalization } from '../../../features/i18n'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'

const MainContentMobile = ({
  programs,
  uniform,
  embed,
  fromOrganization,
}) => {
  const { translate } = useInternationalization()
  const [activeTab, setActiveTab] = React.useState(translate('VIEW', 'list'))
  const query = qs.parse(useLocation().search)

  return (
    <div>
      {
        embed ? (
          <div className="container mx-auto">
            <ListNav
              embed={embed}
              fromOrganization={fromOrganization}
              onChange={setActiveTab}
              activeTab={activeTab}
            />
          </div>
        ) : <ListNav
          fromOrganization={fromOrganization}
          onChange={setActiveTab}
          activeTab={activeTab}
        />
      }
      {
        Object.keys(query).length === 0 &&
        <Featured data={programs} embed={embed}/>
      }
      <section className="container mx-auto">
        <div className="flex flex-wrap -mx-4 pb-5">
          <main className="w-full px-4">
            <PaginatedList
              query={query}
              defaultData={programs}
            />
          </main>
        </div>
      </section>
      <FloatingFilter />
    </div>
  )
}

export { MainContentMobile }
